
module dg.actions {

    class KpiController {

        public showPercent: Boolean;
        public value: dg.domain.IDomainObject;
        public corelatedProperties: dg.restfulApi.DomainObjectPropertyMetadata[];
        public displayName: string;
        //public precision: number = 0;
    
        public constructor(
            protected $scope: ng.IScope,

        ) {
        }


        $onInit() {
            
        }

        $onChanges(changes) {
            if (this.value) {
                //console.log(this.value)
                this.showPercent = this.value.dgMeta.properties.currentValue.dataType == dg.restfulApi.DG_DATA_TYPES.Percent;

                //if (this.value.dgMeta.properties.currentValue.precision) {
                //    this.precision = this.value.dgMeta.properties.currentValue.precision;
                //}
                //console.log(this.precision)

                this.corelatedProperties = Object.keys(this.value.dgMeta.properties).filter((key => {
                    return this.value.dgMeta.properties[key].id != 'currentValue';
                })).reduce((arr, key) => (arr.push(this.value.dgMeta.properties[key]), arr), [])
            }
        }

    }

    angular.module('dg.actions').component('kpi', {
        bindings: {
            value: '<',
            displayName: '@'
        },
        controller: KpiController,
        templateUrl: '/digmo/src/actions/kpi/kpi.html'
    });
}